module.exports = __webpack_public_path__ + "img/impression.04b96587.svg";